import { render, staticRenderFns } from "./RepositoryResult.vue?vue&type=template&id=a1f748a8&scoped=true&"
import script from "./RepositoryResult.vue?vue&type=script&lang=js&"
export * from "./RepositoryResult.vue?vue&type=script&lang=js&"
import style0 from "./RepositoryResult.vue?vue&type=style&index=0&id=a1f748a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1f748a8",
  null
  
)

export default component.exports